import React from 'react';
import { useNaphthaleneStore } from '../store/useNaphthaleneStore';

export function NaphthaleneTable() {
  const { recordedData } = useNaphthaleneStore();

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden flex flex-col h-full shadow-sm">
      <div className="p-4 border-b border-border flex justify-between items-center bg-muted/30">
        <div>
          <h3 className="text-lg font-medium text-foreground flex items-center gap-2">
            Observation Results
          </h3>
          <p className="text-sm text-muted-foreground mt-1">Record temperature every 30 seconds</p>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto p-4 custom-scrollbar">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-border">
              <th className="p-2 text-foreground font-medium">Time (s)</th>
              <th className="p-2 text-foreground font-medium">Temp (°C)</th>
              <th className="p-2 text-foreground font-medium">State of Matter</th>
            </tr>
          </thead>
          <tbody>
            {recordedData.length === 0 ? (
              <tr>
                <td colSpan={3} className="p-4 text-center text-muted-foreground italic">
                  No data recorded yet. Wait for 30s intervals!
                </td>
              </tr>
            ) : (
              recordedData.map((data, idx) => (
                <tr key={idx} className="border-b border-border/50 hover:bg-muted/50 transition-colors">
                  <td className="p-2 font-mono text-blue-500 dark:text-blue-400">{data.time.toFixed(0)}</td>
                  <td className="p-2 font-mono text-orange-500 dark:text-orange-400">{data.temp.toFixed(1)}</td>
                  <td className="p-2 text-foreground">{data.state}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
